import { useMemo } from 'react'
import { Box, Heading } from '@grupoboticario/flora-react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as ReceivedIcon } from '../images/icon_received.svg'
import { ReactComponent as WaitingIcon } from '../images/icon_waiting.svg'
import { ReactComponent as PinIcon } from '../images/icon_pin.svg'
import { ReactComponent as DeliveringIcon } from '../images/icon_delivering.svg'
import { ReactComponent as DeliveredIcon } from '../images/icon_delivered.svg'
import { ReactComponent as CanceledIcon } from '../images/icon_canceled.svg'
import Stepper from './Stepper'
import useBreakpoint from '../hooks/useBreakpoint'
import { useTracking } from '../TrackingContext'

const Forecast = () => {
  const data = useTracking()
  const { isMobile } = useBreakpoint()
  const { t, i18n } = useTranslation()

  const steps: Partial<TStep>[] = [
    { title: t('orderReceived'), Icon: ReceivedIcon },
    { title: t('waitingTransport'), Icon: WaitingIcon },
    { title: t('inTransit'), Icon: PinIcon },
    { title: t('delivering'), Icon: DeliveringIcon },
    { title: t('delivered'), Icon: DeliveredIcon }
  ]

  const findStatus = (index: number) => {
    if (!data) return null

    const finder = (item: TTracking) => item.nrEtapa === String(index + 1)
    const current = data.orderTraceabilityModel.timeLineSteps?.find(finder)

    return current
  }

  const currentStatus = (index: number): Partial<TStep> => {
    const prev = index > 0 ? findStatus(index - 1) : null
    const current = findStatus(index)

    const getDate = (raw: string) => {
      const dateRaw = new Date(raw)
      const date = dateRaw.toLocaleDateString(i18n.language)
      const time = dateRaw.toLocaleTimeString(i18n.language, { timeStyle: 'short' })
      return `${date} ${time}`
    }

    if (!current) return {}

    const newCurrent: Partial<TStep> = { description: !!current.dtStatus ? getDate(current.dtStatus) : '' }

    if (!!current.label) newCurrent.label = current.label

    if (!!current.dtStatus) {
      newCurrent.className = 'success'
    }

    if (!!current.nrAlerta && current.nrEtapa !== '5') {
      newCurrent.className = 'warning'
    }

    if (!!current.nrAlerta && current.nrEtapa === '5') {
      newCurrent.Icon = CanceledIcon
      newCurrent.className = 'error'
    }

    if (!!prev && !!prev.nrAlerta && !!current.dtStatus && !current.nrAlerta && prev.dtStatus > current.dtStatus) {
      newCurrent.description = ''
      newCurrent.className = ''
    }

    return newCurrent
  }

  const status = useMemo(() => {
    const arr = steps.map((item: Partial<TStep>, index: number) => {
      const current = currentStatus(index)
      const newItem: TStep = {
        title: current.label || item.title,
        description: current.description,
        Icon: item.Icon,
        className: current.className
      }

      return newItem
    })

    const finalArr = isMobile ? arr.reverse() : arr

    return finalArr
  }, [data, i18n.language])

  if (!data) return <div />

  return (
    <Box>
      {!status[4].description && data.orderTraceabilityModel.dtPrevisaoEntregaAtualizada && (
        <Heading as="h2" css={{ fontSize: '18px', lineHeight: '28px', fontWeight: 300 }}>
          {t('updatedForecastDelivery')}:
          {' ' + data.orderTraceabilityModel.dtPrevisaoEntregaAtualizada.split('-').reverse().join('/')}
        </Heading>
      )}

      {!status[4].description && data.orderTraceabilityModel.dtprevisaoentrega && (
        <Heading as="h2" css={{ fontSize: '24px', lineHeight: '28px', fontWeight: 500 }} color="$success-standard">
          {t('forecastDelivery')}: {data.orderTraceabilityModel.dtprevisaoentrega.split('-').reverse().join('/')}
        </Heading>
      )}

      <Stepper steps={status} allPainted />
    </Box>
  )
}

export default Forecast
